module.exports = __webpack_public_path__ + "img/042.fe872d5f.jpeg";